import { render, staticRenderFns } from "./mobile_huodeLive.vue?vue&type=template&id=16fc4453&scoped=true"
import script from "./mobile_huodeLive.vue?vue&type=script&lang=js"
export * from "./mobile_huodeLive.vue?vue&type=script&lang=js"
import style0 from "./mobile_huodeLive.vue?vue&type=style&index=0&id=16fc4453&prod&scoped=true&lang=css"
import style1 from "./mobile_huodeLive.vue?vue&type=style&index=1&id=16fc4453&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fc4453",
  null
  
)

export default component.exports